export const rendererSelectors = {
  jumpToTodayButton: 'jump-to-today-button',
};
